import { ReactComponent as Frame } from "./frame.svg";
import ScannerLine from "./ScannerLine";
import SvgContainer from "src/components/SvgContainer";
import { Flex, Spinner } from "@chakra-ui/react";

export default function ScannerUI({ mode, videoReady, processing }) {
  const size = mode === "fullScreen" ? 256 : 205;
  return (
    <Flex w={size} h={size} justifyContent="center" alignItems="center">
      {videoReady && (
        <>
          <SvgContainer
            icon={Frame}
            size={size}
            style={{
              width: size,
              height: size,
              boxShadow: `0 0 10000px 10000px rgba(0, 0, 0, 0.4), inset 0 0 0 3px rgba(0, 0, 0, 0.4)`,
              borderRadius: "2rem"
            }}
          />
          {!processing && <ScannerLine size={size} />}
        </>
      )}

      {(processing || !videoReady) && <Spinner pos="absolute" />}
    </Flex>
  );
}
